import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { Eyebrow } from '@/components/generals/eyebrow'
import { ViewingForm } from '@/components/landing/viewing-form'

const steps = [
    {
        title: "Send your request",
        body: "Share a few details and the time that suits you best."
    },
    {
        title: "We'll be in touch",
        body: "We contact you personally to confirm a private appointment."
    },
    {
        title: "Walk through at your pace",
        body: "See the homes, the gardens and the estate, with no rush and no crowd."
    }
]

/*
   Private viewings
   Left: what to expect, in three numbered steps. Right: the enquiry form.
*/
export const ViewingSection: FC = (): ReactNode => {
    return (
        <section id='enquire' aria-labelledby='enquire-heading' className='border-t border-stone bg-sand py-24 lg:py-32'>
            <div className='mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10'>
                <Reveal className='lg:col-span-5'>
                    <Eyebrow>
                        Private viewings
                    </Eyebrow>

                    <h2 id='enquire-heading' className='mt-6 font-heading text-4xl leading-[1.08] sm:text-5xl'>
                        See Rockwood <em className='italic text-forest'>for yourself</em>
                    </h2>

                    <p className='mt-6 text-[1.0625rem] leading-relaxed text-muted-foreground'>
                        Viewings are by private appointment, so there is never a crowd and always time for your questions. Tell us a little about what you're looking for and we'll arrange a time that suits you.
                    </p>

                    <ol className='mt-10 space-y-7 border-t border-stone pt-8'>
                        {steps.map((step, index) => (
                            <li key={step.title} className='flex gap-5'>
                                <span aria-hidden='true' className='w-8 shrink-0 font-heading text-2xl italic leading-none text-brass'>
                                    {`0${index + 1}`}
                                </span>

                                <div>
                                    <p className='font-medium'>
                                        {step.title}
                                    </p>

                                    <p className='mt-1 text-sm leading-relaxed text-muted-foreground'>
                                        {step.body}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ol>
                </Reveal>

                <Reveal delay={120} className='lg:col-span-7'>
                    <ViewingForm />
                </Reveal>
            </div>
        </section>
    )
}
